import { CustomError } from '../../../lib/custom-error';
import type { Question, Relation } from '../../types';

export class NextQuestionNotFoundError extends CustomError {
  constructor(...args: ConstructorParameters<typeof CustomError>) {
    super(...args);
  }
}

export const getNextQuestion = (questions: Question[], suitableRelation?: Relation): Question => {
  const nextQuestion = questions.find(({ id }) => id === suitableRelation?.form_next_question_id);
  if (!nextQuestion) {
    throw new NextQuestionNotFoundError();
  }

  return nextQuestion;
};
